export const SET_COLLAB = 'SET_COLLAB'

export const setCollab = ({ name, value }) => {
  return {
    type: SET_COLLAB,
    name,
    value
  }
}
